import React from 'react';
import { render } from 'react-dom';
import { InertiaApp } from '@inertiajs/inertia-react';
import { InertiaProgress } from '@inertiajs/progress';
import { createInertiaApp } from '@inertiajs/inertia-react'
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
// import './utils/i18n';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

Sentry.init({
    dsn: process.env.MIX_SENTRY_REACT_DSN,
    integrations: [new Integrations.BrowserTracing()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    enabled: !!process.env.MIX_SENTRY_REACT_DSN,
    environment: process.env.MIX_APP_ENV,
});

require('./bootstrap');

InertiaProgress.init();

createInertiaApp({
    resolve: name => require(`./Pages/${name}`).default,
    setup({ el, App, props }) {
        render(<App {...props} />, el)
    },
});
